export enum LoadingEnum {
  Lazy = 'lazy',
  Eager = 'eager',
}
